// src/pages/Unauthorized.tsx
import React from "react";

const Unauthorized: React.FC = () => {
  return (
    <div style={{ padding: "50px", textAlign: "center" }}>
      <h1>⛔ Accès refusé</h1>
      <p>Vous n'avez pas les permissions nécessaires pour accéder à cette page.</p>
    </div>
  );
};

export default Unauthorized;
